import { ReactElement, useMemo } from 'react';
import DeclarationField from 'views/declarations/common/DeclarationField';
import { getFormikProps } from 'views/declarations/utils/form-utils';
import { useTranslation } from 'react-i18next';
import CountrySelect from '../../../../../components/ui/composed/declarations/CountrySelect';
import useFormUtils from '../../../../../hooks/useFormUtils';
import { AvailableForms } from '../../../../../hooks/useHideEntities';
import { ValidationSchema, validators } from '../validations/validations';

export type Fields = 'countryCode';

export const countryOfDestinationCodeBlockValidation: {
    childValidators: {
        'goodsShipment.destination': ValidationSchema<Fields>;
    };
} = {
    childValidators: {
        'goodsShipment.destination': {
            childValidators: {
                countryCode: [validators.exact(2)],
            },
        },
    },
};

export const countryOfDestinationCodeBlockRequiredValidation: {
    childValidators: {
        'goodsShipment.destination': ValidationSchema<Fields>;
    };
} = {
    childValidators: {
        'goodsShipment.destination': {
            childValidators: {
                countryCode: [validators.required(), validators.exact(2)],
            },
        },
    },
};

export const countryOfDestinationCodeBlockProductValidation: {
    childValidators: {
        destination: ValidationSchema<Fields>;
    };
} = {
    childValidators: {
        destination: {
            childValidators: {
                countryCode: [validators.exact(2)],
            },
        },
    },
};

interface Props extends BlockProps<Fields>, DeclarationBlockProps<AvailableForms, Fields> {}

const CountryOfDestinationCodeBlock = ({
    path = 'goodsShipment.destination',
    declarationOptions,
}: Props): ReactElement => {
    const { t } = useTranslation('form');
    const { formTypeForCds: formType } = useFormUtils();

    const ucc = useMemo(() => '5/8', []);

    return (
        <DeclarationField pathPrefix={path} name="countryCode">
            {({ form, field }) => (
                <CountrySelect
                    refNumber={ucc}
                    required={declarationOptions?.[formType]?.fieldOptions?.countryCode?.required}
                    label={t('countryDestinationCode')}
                    {...getFormikProps(field.name, form)}
                    condensed
                />
            )}
        </DeclarationField>
    );
};

export default CountryOfDestinationCodeBlock;
